export default {
  en: {
    BUTTON_ADD_NEW_ADJUSMENT: 'Add New Modifier',
    BUTTON_RESET_ADJUSMENTS: 'Clear All Modifiers',
    BUTTON_CANCEL_NEW_ADJUSMENTS: 'Revert Unsaved Changes',
    MESSAGE_BID_MODIFIER_LIMIT: 'Limit of 100 Bid Modifiers'
  }
};